module.exports = __webpack_public_path__ + "img/moscow_mule.85916ea6.jpg";